import template from "./verpackung-kombi-list-page.html.twig";

Packlab.Component.register('verpackung-kombi-list-page', {
    template,

    inject: [ 'apiClient' ],

    data() {
        return {
            isLoading: false,
            kombiVerpackungen: null
        }
    },

    computed: {
        columns() {
            return [
                {
                    field: 'name',
                    label: this.$t('Bezeichnung')
                },
                {
                    field: 'recyclingQuote',
                    label: 'recyclingQuote',
                    type: 'percentage',
                    align: 'right'
                },
                {
                    field: 'certificate',
                    label: 'certificate',
                    align: 'center'
                },
                {
                    field: 'vpRuleset.name',
                    label: this.$t('Mindeststandard'),
                },
                {
                    field: 'created',
                    label: this.$t('hinzugefügt'),
                    type: 'datetime'
                },
                {
                    field: 'changed',
                    label: this.$t('geändert'),
                    type: 'datetime'
                }
            ];
        }
    },

    created() {
        this.loadKompiVerpackungen();
    },

    methods: {
        loadKompiVerpackungen() {
            this.isLoading = false;
            this.apiClient.getKombiVerpackungen()
                .then((result) => {
                    this.kombiVerpackungen = result.kombiVerpackungen;
                })
                .catch(() => { this.isLoading = false; });
        },

        onClickCell({ field, row }) {
            if(field !== "certificate") {
                return;
            }
            const certificate = row?._certificate_data?.value || null;
            if(!certificate) {
                return;
            }
            this.apiClient.getVerpackungZertifikatPdf(certificate.objectName, certificate.objectId)
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = `data:${response.fileType};base64,${response.contents}`;;
                    link.setAttribute('download', response.fileName);
                    document.body.appendChild(link);
                    link.click()
                    this.isPreparingDownload = false;
                })
        }
    }
});